// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"pp-z","breadcrumbForward":"qp-z","breadcrumbBack":"rp-z","selected":"sp-z"};